import React, { useEffect, useState } from "react";
import Input from "../../../../../core/Inputs/DefaultInput";
//mport SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader';
//import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { apiRequest } from "../../../../../services/apiService";
import { useVerifySurveyId } from "../../../../../hooks";
import { useTranslation } from 'react-i18next';

// 
export default function EloquaSettings() {
    const { survey_name } = useSelector((state) => state.permissionsData);
    const survey_id = useVerifySurveyId();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [formurl, setFormUrl] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({});

    const validateFields = () => {
        const newErrors = {};

        if (!formurl.trim()) newErrors.formurl = "Form URL is required.";
        if (!companyName.trim())
            newErrors.companyName = "Company Name is required.";
        if (!userName.trim()) newErrors.userName = "User Name is required.";
        if (!password.trim()) newErrors.password = "Password is required.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const save = async () => {
        if (!validateFields()) {
            toast.error("Please fill in all required fields.");
            return;
        }

        const data = { formurl, companyName, userName, password };
        const payload = { su_survey_id: survey_id, settings: data, type: 2 };

        const { response, error } = await apiRequest({
            method: "POST",
            url: "/survey/updateLeadManagementPluginData",
            data: payload,
            showErrorToast: false,
        });

        if (response) {
            localStorage.setItem("token_id", response.data.token);
            response.data.statusCode === 200
                ? toast.success(response.data.msg)
                : toast.error(response.data.msg);
        } else if (error) {
            toast.error(error);
        }
    };

    const getLeadManagementPluginData = async () => {
        const payload = { su_survey_id: survey_id, type: 2 };
        const { response, error } = await apiRequest({
            method: "POST",
            url: "/survey/getLeadManagementPluginData",
            data: payload,
            showErrorToast: false,
        });

        if (
            response &&
            response.data.statusCode === 200 &&
            response?.data?.data[0]?.settings
        ) {
            const settings = JSON.parse(response.data.data[0].settings);
            setFormUrl(settings.formurl);
            setCompanyName(settings.companyName);
            setUserName(settings.userName);
            setPassword(settings.password);
            localStorage.setItem("token_id", response.data.token);
        } else if (error) {
            toast.error(error);
        }
    };

    useEffect(() => {
        if (survey_id) {
            getLeadManagementPluginData();
        }
    }, [survey_id]);

    const cancel = () => {
        navigate("/admin/survey/integrations?survey_id=" + survey_id);
    };

    return (
        <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column bg-white">
            <div className="share-page-padding dashboard-page-wrap">
                <div className="page-heading">
                    <div className="d-flex variable-pg-wrapper flex-grow-1">
                        
                        <div className="flex-grow-1 variable-pg-content">
                            <div className="custom-breadcrumb">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/survey/list">{t('survey.title')}</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <strong>{t('settings.integration.tittle')}</strong>
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <div className="form-preview-wrapper padding-top-30">
                                <div className="page-content-wrap variables-main-container p-0">
                                    <div className="main-sec-wrap">
                                        <div className="pagesRow varPg">
                                            {/* Form URL Input */}
                                            <div className="row gx-12px">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-12px">
                                                        <label className="form-label-custom">
                                                           {t('settings.integration.formURL')}

                                                        </label>
                                                        <Input
                                                            type="text"
                                                            fill={true}
                                                            placeholder="Enter Eloqua form URL..."
                                                            value={formurl}
                                                            onChange={window.modulePermissions.M17.edit == 1 ? (e) => setFormUrl(e.target.value) : undefined}
                                                            readOnly={window.modulePermissions.M17.edit != 1}
                                                        />
                                                        {errors.formurl && (
                                                            <small className="text-danger">
                                                                {errors.formurl}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Company Name Input */}
                                            <div className="row gx-12px">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-12px">
                                                        <label className="form-label-custom">
                                                            {t('settings.integration.companyName')}

                                                        </label>
                                                        <Input
                                                            type="text"
                                                            fill={true}
                                                            placeholder="Enter company name..."
                                                            value={companyName}
                                                            onChange={window.modulePermissions.M17.edit == 1 ? (e) => setCompanyName(e.target.value) : undefined}
                                                            readOnly={window.modulePermissions.M17.edit != 1}
                                                        />
                                                        {errors.companyName && (
                                                            <small className="text-danger">
                                                                {errors.companyName}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* User Name Input */}
                                            <div className="row gx-12px">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-12px">
                                                        <label className="form-label-custom">
                                                         {t('settings.integration.userName')}

                                                        </label>
                                                        <Input
                                                            type="text"
                                                            placeholder="Enter user name..."
                                                            fill={true}
                                                            value={userName}
                                                            onChange={window.modulePermissions.M17.edit == 1 ? (e) => setUserName(e.target.value) : undefined}
                                                            readOnly={window.modulePermissions.M17.edit != 1}
                                                        />
                                                        {errors.userName && (
                                                            <small className="text-danger">
                                                                {errors.userName}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Password Input */}
                                            <div className="row gx-12px">
                                                <div className="col-lg-12">
                                                    <div className="form-group mb-12px">
                                                        <label className="form-label-custom">
                                                            {t('settings.integration.password')}
   
                                                        </label>
                                                        <Input
                                                            type="password"
                                                            placeholder="Enter password..."
                                                            value={password}
                                                            fill={true}
                                                            onChange={window.modulePermissions.M17.edit == 1 ? (e) => setPassword(e.target.value) : undefined}
                                                            readOnly={window.modulePermissions.M17.edit != 1}
                                                        />
                                                        {errors.password && (
                                                            <small className="text-danger">
                                                                {errors.password}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Buttons */}
                                            <div className="button-wrap pt-2">
                                                {window.modulePermissions.M17.edit == 1 && <button
                                                    className="btn btn-primary next-btn"
                                                    type="button"
                                                    onClick={save}
                                                >
                                                    {t('settings.integration.save')}
                                                </button>}
                                                <button
                                                    type="button"
                                                    className="btn btn-bordered color-cancel ms-3"
                                                    onClick={cancel}
                                                >
                                                     {t('settings.team.action.cancel')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}





